import { createContext } from 'react'

/**
 * Wat getPublicLiveReport2 meestuurt over de deelnemer van het rapport
 * (functions/liveReports/publicPersonaData.js). Een soort staat er alleen in als
 * het rapport een widget van die soort heeft.
 * @typedef {object} PublicPersonaData
 * @property {{ ID: string, Name?: string }|null} persona - null: de deelnemer bestaat niet (meer)
 * @property {Array<object>} [presence] - Alle aanwezigheidsregels; de periode filtert de client
 * @property {Array<object>} [goals] - Doelen in hun opgeslagen vorm (personaGoalFields)
 * @property {Array<{ID: string, Effect?: string}>} [effects] - De effecten van die doelen
 * @property {Object<string, *>} [profile] - Per gekozen veld de waarde; lege velden ontbreken
 * @property {{ begin: number|null, current: number|null }} [ladder] - Begintrede en huidige trede (participatieladder)
 * @property {Array<{ID: string, Datum?: string, Created?: string, Scores?: Object<string, number|null>}>} [workSkills] - Beoordelingen arbeidsvaardigheden, alleen datum en scores
 */

/**
 * @typedef {object} PublicReport
 * @property {string} reportId - LiveReports2 `ID` of the shared report
 * @property {string} code - Share code the viewer entered ('' for an open report)
 * @property {{quotes: Array<{ID: string, Quote?: string, Name?: string}>, anecdotes: Array<{ID: string, Anecdote?: string}>}} [storytelling]
 *   - Teksten achter de quote- en anekdotewidgets, meegestuurd door getPublicLiveReport2
 * @property {PublicPersonaData|null} [personaData] - De gegevens achter de deelnemerwidgets;
 *   null zonder deelnemer op het rapport (docs/features/livereport-per-deelnemer.md, T12)
 */

/**
 * Set by the public report page (`LiveReportOpen2`) only. Data hooks read it to
 * fetch through getPublicLiveReportData instead of the logged-in
 * fetchHierarchyData / direct Firestore reads, which an anonymous viewer is
 * refused. `null` everywhere else.
 * AI-CONTEXT: See docs/features/public-livereport-data.md
 *
 * @type {React.Context<PublicReport|null>}
 */
const PublicReportContext = createContext(/** @type {PublicReport|null} */ (null))

export default PublicReportContext
